import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { HeaderNote } from './HeaderNote';
import { Stack } from '@mui/material';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { CreateOrderForm } from './CreateOrderForm';
import { EquipmentProvider } from 'Context';
import { CustomMetaTitle, Header2 } from 'Components';
import { HeaderTitle } from './HeaderTitle';

export const EquipmentCreateOrder = () => {
  return (
    <EquipmentProvider>
      <CustomMetaTitle
        title={
          Dictionary[DICTIONARY.Equipment].title +
          ' - ' +
          Dictionary[DICTIONARY.Equipment].createOrder.title
        }
      />
      <LinkReturnToMain
        label={Dictionary[DICTIONARY.Equipment].breadcrumbs}
        link='/equipment'
        internal
      />
      <Stack sx={{ maxWidth: '960px', pb: 2 }}>
        <HeaderTitle />
        <HeaderNote />
        <CreateOrderForm />
      </Stack>
    </EquipmentProvider>
  );
};
